import { useState, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';

export const useCreditCheck = (requiredCredits: number) => {
  const { user, refreshCredits } = useAuth();
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  
  const hasSufficientCredits = useCallback((): boolean => {
    if (!user) return false;
    return (user.credits || 0) >= requiredCredits;
  }, [user, requiredCredits]);
  
  const checkCredits = useCallback((): boolean => {
    const sufficient = hasSufficientCredits();
    
    if (!sufficient) {
      const shortfall = requiredCredits - (user?.credits || 0);
      toast.error(`Insufficient credits. You need ${shortfall} more credit${shortfall > 1 ? 's' : ''}.`, {
        duration: 4000,
        icon: '💳',
      });
    }
    
    return sufficient;
  }, [hasSufficientCredits, requiredCredits, user]);
  
  const openPurchaseModal = useCallback(() => {
    setShowPurchaseModal(true);
  }, []);
  
  const closePurchaseModal = useCallback(() => {
    setShowPurchaseModal(false);
    // Refresh credits when modal closes
    refreshCredits();
  }, [refreshCredits]);
  
  return {
    hasSufficientCredits: hasSufficientCredits(),
    checkCredits,
    openPurchaseModal,
    closePurchaseModal,
    showPurchaseModal,
    currentCredits: user?.credits || 0,
    requiredCredits,
    shortfall: Math.max(0, requiredCredits - (user?.credits || 0)),
  };
};

